// Settings configured here will be merged into the final config object.
import { HearkenStatus } from 'types/hearkenStatus'

export default {
  articleId: '281088769632',
  googleSheetKey: '1EAv44ui_dujftqV4b2jAX04F8H5VX3lBrfX-t9-BJw0',
  embeds: {
    [HearkenStatus.VOTING]: [
      // 'https://modules.wearehearken.com/tages-anzeiger/embed/3718.js'
      'https://modules.wearehearken.com/der-bund-tamedia/embed/5467.js'
    ],
    [HearkenStatus.COLLECTING]: [
      // 'https://modules.wearehearken.com/der-bund-tamedia/embed/5129.js'
      'https://modules.wearehearken.com/der-bund-tamedia/embed/5444.js'
    ],
    [HearkenStatus.PUBLISHING]: [],
    [HearkenStatus.INVESTIGATING]: []
  }
}
